import { FramedOperative } from '@amzn/ring-cs-chatbot-widget';
import React from 'react';
import { LiveSessionWrapper } from './SessionComponent';

export const WidgetOperative: React.FC = () => {
    return (
        <FramedOperative
            Ui={LiveSessionWrapper}
        />
    )
}